module.exports = __webpack_public_path__ + "static/img/index_head.632488e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index_head.png
// module id = fVdN
// module chunks = 1